export const environment = {
  production: true,
  version: "0.0.1 (beta)",
  graphql_endpoint: "https://graph.fdc-system.storexweb.team/graphql",
  url: "https://files.fdc-system.storexweb.team/",
  skip_auth: false,
  REPORT_URL: "",

  firebase: {
    apiKey: "",
    authDomain: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "",
  },
  VAPIDKEY: "",
  routes_api_key: "",
  GOOGLE_SCRIPT: "https://maps.googleapis.com/maps/api/js",
  google_api_key: "",
  places_key: "",
  RECAPTCHA_SITE_KEY: "6Lc3kpUsAAAAAHccF5etMZmk55prQIfszi_lO0dU",
  RECAPTCHA_SECRET_KEY: "6Lc3kpUsAAAAAFofovGufKuyXEhx0I-vDiofpnBj",
  RECAPTCHA_API_URL: "https://www.google.com/recaptcha/api.js?render=explicit",
  REALTIME_SOCKET_URL: "",
};
